import { render, staticRenderFns } from "./PaymentResultTab.vue?vue&type=template&id=3f62f3e2&scoped=true&"
import script from "./PaymentResultTab.vue?vue&type=script&lang=js&"
export * from "./PaymentResultTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResultTab.vue?vue&type=style&index=0&id=3f62f3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62f3e2",
  null
  
)

export default component.exports